import { addDays, format } from 'date-fns';
import { IGerarRemessaAilos } from './types';
import { Arquivo } from '@/lib/Arquivo';
import { removerCaracterEspecial } from "@/utils/removerCaracterEspecial";

export function gerarRemessa({ dados }: IGerarRemessaAilos) {
  try {
    const { dadosBancario, beneficiario, boletos } = dados.remessa;

    const arquivo = new Arquivo();
    const dataAtual = new Date();
    const data = format(dataAtual, 'ddMMyyyy');
    const hora = format(dataAtual, 'HHmmss');

    const convenio = dadosBancario.convenio.padStart(7, '0');
    const numero =
      dadosBancario.conta.padStart(7, '0') + dadosBancario.contaDigito;

    const remessa = `REM${convenio}-${numero}-${data}.REM`;

    // Header do arquivo
    arquivo.add('085');
    arquivo.add('0000');
    arquivo.add('0');
    arquivo.add('         ');
    arquivo.add('2');
    arquivo.add(beneficiario.cnpj);
    arquivo.add(dadosBancario.convenio.padEnd(20, ' '));
    arquivo.add(dadosBancario.agencia.padStart(5, '0'));
    arquivo.add(dadosBancario.agenciaDigito);
    arquivo.add(dadosBancario.conta.padStart(12, '0'));
    arquivo.add(dadosBancario.contaDigito);
    arquivo.add(' ');
    arquivo.add(removerCaracterEspecial(beneficiario.nome).substring(0, 30).padEnd(30, ' '));
    arquivo.add('AILOS'.padEnd(30, ' '));
    arquivo.add('          ');
    arquivo.add('1');
    arquivo.add(data);
    arquivo.add(hora);
    arquivo.add(dadosBancario.numeroRemessa.padStart(6, '0'));
    arquivo.add('087');
    arquivo.add('00000');
    arquivo.add(' '.padEnd(20, ' '));
    arquivo.add(' '.padEnd(20, ' '));
    arquivo.add(' '.padEnd(29, ' '));

    arquivo.addLine();

    // Header do lote
    arquivo.add('085');
    arquivo.add('0001');
    arquivo.add('1');
    arquivo.add('R');
    arquivo.add('01');
    arquivo.add('  ');
    arquivo.add('045');
    arquivo.add(' ');
    arquivo.add('2');
    arquivo.add(beneficiario.cnpj.padStart(15, '0'));
    arquivo.add(dadosBancario.convenio.padEnd(20, ' '));
    arquivo.add(dadosBancario.agencia.padStart(5, '0'));
    arquivo.add(dadosBancario.agenciaDigito);
    arquivo.add(dadosBancario.conta.padStart(12, '0'));
    arquivo.add(dadosBancario.contaDigito);
    arquivo.add(' ');
    arquivo.add(removerCaracterEspecial(beneficiario.nome).substring(0, 30).padEnd(30, ' '));
    arquivo.add(' '.padEnd(40, ' '));
    arquivo.add(' '.padEnd(40, ' '));
    arquivo.add(dadosBancario.numeroRemessa.padStart(8, '0'));
    arquivo.add(data);
    arquivo.add('00000000');
    arquivo.add(' '.padEnd(33, ' '));

    arquivo.addLine();

    let sequencia = 0;
    let quantidadeRegistro = 0;
    let total = 0;

    // Registro Detalhe – Segmento P
    for (const boleto of boletos) {
      const { pagador } = boleto;
      const vencimento = format(new Date(boleto.vencimento), 'ddMMyyyy');
      total += Number(boleto.valor);

      // Cálculos de juros
      const codigoJuro = dadosBancario.jurosMes > 0 ? '2' : '3';
      const juros =
        dadosBancario.jurosMes > 0
          ? dadosBancario.jurosMes.toFixed(2)
          : '000000000000000';

      // Cálculos de desconto
      const jurosVencimento = format(
        addDays(new Date(boleto.vencimento), 1),
        'ddMMyyyy',
      );
      const codigoDesconto = dadosBancario.descontoPagamento > 0 ? '2' : '0';

      const desconto = boleto.desconto > 0
        ? boleto.desconto.toFixed(2)
        : dadosBancario.descontoPagamento > 0
          ? dadosBancario.descontoPagamento.toFixed(2)
          : '000000000000000';

      let diasProtesto = '00';
      let protesto = '3';

      switch (dadosBancario.tipo_protesto) {
        case 'Nenhum':
          protesto = '3';
          diasProtesto = '00';
          break;
        case 'Protestar':
          protesto = '1';
          diasProtesto = dadosBancario.diasProtesto.toString().padStart(2, '0');
          break;
        case 'Negativar':
          protesto = '2';
          diasProtesto = dadosBancario.diasProtesto.toString().padStart(2, '0');
          break;
        default:
          protesto = '3';
          diasProtesto = '00';
          break;
      }

      arquivo.add('085');
      arquivo.add('0001');
      arquivo.add('3');
      arquivo.add((++sequencia).toString().padStart(5, '0'));
      arquivo.add('P');
      arquivo.add(' ');
      arquivo.add('01');
      arquivo.add(dadosBancario.agencia.padStart(5, '0'));
      arquivo.add(dadosBancario.agenciaDigito);
      arquivo.add(dadosBancario.conta.padStart(12, '0'));
      arquivo.add(dadosBancario.contaDigito);
      arquivo.add(' ');
      arquivo.add(boleto.nossoNumero.padEnd(20, ' '));
      arquivo.add('1');
      arquivo.add('1');
      arquivo.add('1');
      arquivo.add('2');
      arquivo.add('2');
      arquivo.add(`${boleto.numeroDocumento}/${boleto.parcela}`.padEnd(15, ' '));
      arquivo.add(vencimento);
      arquivo.add(
        Number(boleto.valor).toFixed(2).replace('.', '').padStart(15, '0'),
      );
      arquivo.add(dadosBancario.agencia.padStart(5, '0'));
      arquivo.add(dadosBancario.agenciaDigito);
      arquivo.add('02'); // especie
      arquivo.add(boleto.aceite); // aceite
      arquivo.add(data);
      arquivo.add(codigoJuro);
      arquivo.add(jurosVencimento);
      arquivo.add(juros.replace('.', '').padStart(15, '0'));
      arquivo.add(codigoDesconto);
      arquivo.add(vencimento);
      arquivo.add(desconto.replace('.', '').padStart(15, '0'));
      arquivo.add('000000000000000');
      arquivo.add('000000000000000');
      arquivo.add(boleto.identificacaoTitulo.padEnd(25, ' ')); // Identificação de título, usar depois
      arquivo.add(protesto);
      arquivo.add(diasProtesto);
      arquivo.add('2');
      arquivo.add('   ');
      arquivo.add('09');
      arquivo.add('0000000000');
      arquivo.add(' ');

      arquivo.addLine();

      // Registro Detalhe – Segmento Q
      let tipoInscricao = '1';

      if (pagador.pessoa === 'F') {
        tipoInscricao = '1';
      } else {
        tipoInscricao = '2';
      }

      pagador.endereco.logradouro = `${
        removerCaracterEspecial(pagador.endereco.logradouro)
        .substring(0, 32)
        .padEnd(32, ' ')}${pagador.endereco.numero.padEnd(8, ' ')}`;

      arquivo.add('085');
      arquivo.add('0001');
      arquivo.add('3');
      arquivo.add((++sequencia).toString().padStart(5, '0'));
      arquivo.add('Q');
      arquivo.add(' ');
      arquivo.add('01');
      arquivo.add(tipoInscricao);
      arquivo.add(pagador.cpfCnpj.padStart(15, '0'));
      arquivo.add(removerCaracterEspecial(pagador.nome).substring(0, 40).padEnd(40, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.logradouro).substring(0, 40).padEnd(40, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.bairro).substring(0, 15).padEnd(15, ' '));
      arquivo.add(pagador.endereco.cep.substring(0, 5).padStart(5, '0'));
      arquivo.add(pagador.endereco.cep.substring(5, 7).padStart(3, '0'));
      arquivo.add(removerCaracterEspecial(pagador.endereco.municipio).substring(0, 15).padEnd(15, ' '));
      arquivo.add(removerCaracterEspecial(pagador.endereco.uf).padEnd(2, ' '));
      arquivo.add('0');
      arquivo.add('000000000000000');
      arquivo.add(' '.padEnd(40, ' '));
      arquivo.add('000');
      arquivo.add(' '.padEnd(20, ' '));
      arquivo.add(' '.padEnd(8, ' '));

      arquivo.addLine();

      dadosBancario.multaAtraso = Number(dadosBancario.multaAtraso || 0);
      if (dadosBancario.multaAtraso > 0) {
        const multa = dadosBancario.multaAtraso.toFixed(2);

        // Registro Detalhe – Segmento R
        arquivo.add('085');
        arquivo.add('0001');
        arquivo.add('3');
        arquivo.add((++sequencia).toString().padStart(5, '0'));
        arquivo.add('R');
        arquivo.add(' ');
        arquivo.add('01');
        arquivo.add('0');
        arquivo.add('00000000');
        arquivo.add('000000000000000');
        arquivo.add('0');
        arquivo.add('00000000');
        arquivo.add('000000000000000');
        arquivo.add('2');
        arquivo.add(vencimento);
        arquivo.add(multa.replace('.', '').padStart(15, '0'));
        arquivo.add(' '.padEnd(10, ' '));
        arquivo.add(' '.padEnd(40, ' '));
        arquivo.add(' '.padEnd(40, ' '));
        arquivo.add(' '.padEnd(20, ' '));
        arquivo.add('00000000');
        arquivo.add('000');
        arquivo.add('00000');
        arquivo.add(' ');
        arquivo.add('000000000000');
        arquivo.add(' ');
        arquivo.add(' ');
        arquivo.add('0');
        arquivo.add('000000000');

        arquivo.addLine();
      }
      quantidadeRegistro++;
    }

    // Registro trailer do lote
    arquivo.add('085');
    arquivo.add('0001');
    arquivo.add('5');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add((sequencia + 3).toString().padStart(6, '0'));
    arquivo.add(quantidadeRegistro.toString().padStart(6, '0'));
    arquivo.add(total.toFixed(2).replace('.', '').padStart(17, '0'));
    arquivo.add('0'.padStart(6, '0'));
    arquivo.add('0'.padStart(17, '0'));
    arquivo.add('0'.padStart(6, '0'));
    arquivo.add('0'.padStart(17, '0'));
    arquivo.add('0'.padStart(6, '0'));
    arquivo.add('0'.padStart(17, '0'));
    arquivo.add(' '.padStart(8, ' '));
    arquivo.add(' '.padStart(117, ' '));

    arquivo.addLine();

    // Registro Trailer de Arquivo
    arquivo.add('085');
    arquivo.add('9999');
    arquivo.add('9');
    arquivo.add(' '.padEnd(9, ' '));
    arquivo.add('000001');
    arquivo.add((sequencia + 4).toString().padStart(6, '0'));
    arquivo.add('000000');
    arquivo.add(' '.padEnd(205, ' '));

    return {
      download: remessa,
      arquivo: arquivo.getArquivo(),
    };
  } catch (error) {
    console.log(error);
    return null;
  }
}
